import React from 'react';

// Shown in the NATIVE app wherever a purchase/rent/store surface would otherwise
// appear. The native app is reader-only: you listen to what you already own; all
// buying happens on the web. No purchase CTA and no external-checkout link is
// rendered here, per Google Play's payments policy for in-app digital goods —
// the website is named in text only, with no tappable link to checkout.
export default function NativeReaderNotice({
  title = 'Available on the web',
  message = 'You can browse, buy and rent audiobooks on the Narratoria website. Anything you get there appears in your library here, ready to listen offline.',
}) {
  return (
    <div className="listening-theme flex min-h-screen w-full flex-col items-center justify-center bg-background px-6 py-12 text-center text-foreground">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-primary text-3xl font-semibold">{title}</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">{message}</p>
        <button
          type="button"
          onClick={() => { window.location.href = '/signin-preview'; }}
          className="bg-primary text-primary-foreground mt-8 inline-flex h-12 w-full items-center justify-center rounded-lg text-base font-semibold"
        >
          Go to my library
        </button>
      </div>
    </div>
  );
}
